import SimpleAPI from 'gpt-simple-api-ts'

const gptAPI = new SimpleAPI({key: process.env.OPENAI_API_KEY})

export default gptAPI
